function dm_a_03_newsletter_signup(){
    const section = document.querySelector('footer .newsletter-signup');
    if (!section) return;

    const enhance = (form) => {
        if (!form || form.dataset.inlineInit === '1') return;

        // Prefer custom classes; fallback to NF defaults
        const input = form.querySelector('.dm-email') ||
            form.querySelector('.nf-field input[type="email"], .nf-field input[type="text"]');

        if (!input) return;

        // Avoid re-wrapping if already wrapped
        if (input.closest('.nf-inline-input')) return;

        const wrap = document.createElement('div');
        wrap.className = 'nf-inline-input';

        // Create visible button with SVG only
        const btn = document.createElement('button');
        btn.type = 'submit';
        btn.className = 'dm-btn-submit';
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-label', 'Submit');

        // inline SVG placeholder (/src/images/arrow.svg)
        btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                <path d="M5.6416 0.5C4.05386 2.08774 1.76228 4.37932 0.872791 5.26881C0.666269 5.47533 0.667705 5.80873 0.874226 6.01525L5.60463 10.7457" stroke="#53565A" stroke-width="1.05766"/>
                <path d="M0.911571 5.64068L10.6802 5.64064" stroke="#53565A"/>
            </svg>
        `;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            // Click the real submit button.
            $(form).find('.submit-wrap [type="submit"]').click();
        });

        const inputParent = input.parentElement;
        inputParent.insertBefore(wrap, input);
        wrap.appendChild(input);
        wrap.appendChild(btn);

        form.dataset.inlineInit = '1';
    };

    const run = () => {
        section.querySelectorAll('.nf-form-cont').forEach(enhance);
    };

    // Run now (if DOM is ready) or on ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
        run();
    }

    // Ninja Forms fires when it (re)renders
    document.addEventListener('nfFormReady', () => run());

    // As a fallback, watch for NF nodes being injected
    const mo = new MutationObserver(() => run());
    mo.observe(section, { childList: true, subtree: true });

    jQuery(document).on('nfFormSubmitResponse', (e, resp) => {
  console.log('NF AJAX OK', resp);
});
}

export { dm_a_03_newsletter_signup };
